<template>
  <div>{{ calcUnit(value || 0) }}{{ conf && conf.bpmConfig && conf.bpmConfig.unit || '' }}</div>
</template>

<script>
import cloneDeep from 'lodash/cloneDeep'
export default {
  props: {
    value: {
      type: [Number, String],
      default: 0
    },
    // 计算公式配置
    conf: {
      type: Object,
      default: () => {}
    },
    // 表单数据
    formData: {
      type: Object,
      default: () => {}
    },
    field: { // 存在于明细表中则有field字段
      type: String,
      default: ''
    },
    fieldData: { // 存在于明细表中则有field字段，明细表某一行数据
      type: Object,
      default: () => {}
    }
  },
  data() {
    return {
      oldRes: '' // 判断数据是够变化，没变化则不提交
    }
  },
  watch: {
    formData: {
      handler(newData) {
        console.log('newData', newData)
        const data = cloneDeep(newData)
        if (!data || Object.keys(data).length === 0) return
        const setting = this.conf.bpmConfig && this.conf.bpmConfig.setting
        const digits = this.conf.bpmConfig && this.conf.bpmConfig.digits
        if (!setting) return
        const myFixed = (num, digit) => {
          let res = 0
          try {
            num = parseFloat(num)
            res = (Math.round((num + Number.EPSILON) * Math.pow(10, digit)) / Math.pow(10, digit)).toFixed(digit)
          } catch (err) {
            res = 0
          }
          return res
        }
        const obj = {}
        const { calcText = '', keyList = [] } = setting
        let calcItemText = calcText
        function handleItem(itemData, reg, key) {
          const cloneData = cloneDeep(itemData)
          Object.keys(cloneData).forEach((item) => {
            if (item !== 'confList') {
              console.log('cloneData[key]', cloneData[key])
              cloneData[key] = cloneData[key] ? cloneData[key] : {}
              cloneData[key][item] = cloneData[item]
            }
          })
          try {
            const fn = new Function(`with(this){
          try {
            const res = eval(${reg});
            this.res = res
          } catch(err) {
            this.res = ''
          }
         }`)
            fn.call(cloneData)// 没有报错,打印出window
          } catch (err) {
            console.log('err', err)
            cloneData.res = '0'
          }
          console.log('obj.res', cloneData.res)
          return cloneData.res
        }
        keyList.forEach((item) => {
          if (item.includes('.')) {
            const key = item.split('.')[0]
            const itemData = data[key]
            // eslint-disable-next-line no-eval
            const reg = eval(`/${key}\.field\\\d*[\\\+\\\-\\\*\\\/](${key}\.field\\\d*([\\\+\\\-\\\*\\\/]${key}.field\\\d*)*)/`)
            console.log('reg', reg)
            const matchText = calcItemText.match(reg)
            console.log('matchText[0]', matchText && matchText[0])
            if (matchText && matchText[0] && Array.isArray(itemData)) {
              let value = 0
              const fieldList = matchText[0].split(/\+\-\*\//)
              let isInForm = false // 判断计算公式在明细表内部且公式内组件全部都在明细表内部
              if (this.field && fieldList.length > 0 && fieldList.every((item) => item.includes(this.field))) {
                isInForm = true
              }
              if (isInForm) {
                const insideFormData = cloneDeep(this.fieldData)
                const insideReg = `/${this.field}./g`
                // eslint-disable-next-line no-eval
                const insideCalc = matchText[0].replace(eval(insideReg), '')
                console.log('insideCalc', insideCalc)
                try {
                  const fn = new Function(`with(this){
                  try {
                    const res = eval(${insideCalc});
                    this.res = res
                  } catch(err) {
                    this.res = '0'
                  }
                }`)
                  fn.call(insideFormData)// 没有报错,打印出window
                } catch (err) {
                  console.log('err', err)
                  insideFormData.res = '0'
                }
                value = isNaN(insideFormData.res) ? '0' : Number(insideFormData.res)
              } else {
                itemData.forEach((item) => {
                  value = value + Number(handleItem(item, matchText[0], key))
                })
              }

              console.log('matchText[0]', matchText[0])
              console.log('value', value)
              calcItemText = calcItemText.replace(matchText[0], String(value))
              console.log('转换后的calcItemText', calcItemText)
            }
          } else {
            obj[item] = Number(data[item]) || 0
          }
        })
        // eslint-disable-next-line no-with
        if (!calcItemText) return
        keyList.forEach((item) => {
          if (item.includes('.')) {
            let value = 0
            const key = item.split('.')
            const arr = data[key[0]] || []
            arr.forEach((item2) => {
              value = value + (item2[key[1]] || 0)
            })
            obj[key[0]] = obj[key[0]] ? obj[key[0]] : {}
            obj[key[0]][key[1]] = Number(value)
          } else {
            obj[item] = Number(data[item]) || 0
          }
        })
        try {
          console.log('calcItemText', calcItemText)
          const fn = new Function(`with(this){
          try {
            const res = eval(${calcItemText});
            this.res = res
          } catch(err) {
            this.res = 0
          }
         }`)
          fn.call(obj)// 没有报错,打印出window
        } catch (err) {
          console.log('err', err)
          obj.res = 0
        }
        if (obj.res === Number.POSITIVE_INFINITY || obj.res === Number.NEGATIVE_INFINITY) {
          obj.res = 0
        }
        if (!obj.res && obj.res !== 0) {
          obj.res = 0
        }
        console.log('obj.res', obj.res)
        if (isNaN(obj.res)) {
          if (this.oldRes === obj.res) return
          this.oldRes = obj.res
          this.$emit('input', Number(obj.res))
        } else {
          if (obj.res > 999999999999999) {
            this.$message.error('数字内容过大，请调整')
          }
          const { bpmConfig: { showDecimal, showPercent }} = this.conf
          if (digits && showDecimal && !showPercent) { // 这个地方计算有点问题 保留小数的时候 直接保留了两位数
            // eslint-disable-next-line eqeqeq
            if (myFixed(this.oldRes, digits) == myFixed(obj.res, digits)) return
            this.oldRes = myFixed(obj.res, digits)
            this.$emit('input', Number(myFixed(obj.res, digits)))
          } else {
            // eslint-disable-next-line eqeqeq
            if (this.oldRes == obj.res) return
            this.oldRes = obj.res
            this.$emit('input', Number(obj.res))
          }
        }
        console.log(' this.value', this.value)
      },
      immediate: true,
      deep: true
    }
  },
  mounted() {},
  methods: {
    toFixed(val, num) {
      val = parseFloat(val)
      return (Math.round((val + Number.EPSILON) * Math.pow(10, num)) / Math.pow(10, num)).toFixed(num)
    },
    thousandNumFormat(num) {
      const str = num.toString().replace(/,/g, '')
      const integer = str.split('.')[0] // 获取整数位
      const decimal = str.split('.')[1] // 获取小数
      let res = []
      if (integer.length > 3) {
        let counter = 0
        for (let i = integer.length - 1; i >= 0; i--) {
          counter++
          res.unshift(integer[i])
          // eslint-disable-next-line eqeqeq
          if (!(counter % 3) && i != 0) {
            res.unshift(',')
          }
        }
        if (decimal) {
          res = res.join('') + '.' + decimal
        } else {
          res = res.join('')
        }
      } else {
        res = str
      }
      return res
    },
    calcUnit(val) {
      const digits = this.conf.bpmConfig && this.conf.bpmConfig.digits // 小数位数
      const showDecimal = this.conf.bpmConfig && this.conf.bpmConfig.showDecimal // 是否取小数
      let value = val
      const { bpmConfig: { showPercent, showPercentile }} = this.conf
      if (showPercent) { // 显示百分比
        value = value * 100
      }
      if (digits && showDecimal) {
        value = this.toFixed(value, digits)
      }
      console.log('value1', value)
      if (showPercentile) {
        value = this.thousandNumFormat(value)
      }
      if (showPercent) {
        value = value + '%'
      }
      return value
    }
  }
}
</script>

<style lang="scss" scoped>

</style>
